import React from 'react'
import styled from '@emotion/styled'
// import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
// import { graphql, useStaticQuery } from 'gatsby'

const Figure = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    position: absolute;
  }

  .mobile {
    display: none;
  }

  .desktop {
    display: block;
  }

  @media (orientation: portrait) {
    .mobile {
      display: block;
    }
    .desktop {
      display: none;
    }
  }

  figcaption {
    position: absolute;
    bottom: 0;
    right: 20px;
    color: black;
    font-size: 0.5rem;
    padding: 0.5rem;
    text-align: right;
    color: white;
    max-width: 40%;
    span {
      display: inline;
      background-color: #222222;
      box-shadow: 2px 1px 0 #222222, -2px -1px 0 #222222, 2px -1px 0 #222222,
        -2px 1px 0 #222222;
      opacity: 0.6;
      font-family: 'Acta Sans', sans-serif;
      text-transform: uppercase;
      word-spacing: 0.1rem;
    }
  }
`

// const allMedia = graphql`
//   query {
//     allWpMediaItem {
//       edges {
//         node {
//           databaseId
//           localFile {
//             childImageSharp {
//               full: gatsbyImageData(
//                 quality: 90
//                 placeholder: NONE
//                 layout: FULL_WIDTH
//                 formats: [JPG]
//                 breakpoints: [750]
//               )
//             }
//           }
//         }
//       }
//     }
//   }
// `

const Image = ({ img, mobileimg }) => {
  // const { allWpMediaItem } = useStaticQuery(allMedia)

  const { url } = img
  const { url: mobileurl } = mobileimg

  // const image = allWpMediaItem.edges.find(({ node }) => node.databaseId === id)
  // const mobileimage = allWpMediaItem.edges.find(
  //   ({ node }) => node.databaseId === mobileid,
  // )
  // const fullImage = image?.node?.localFile?.childImageSharp?.full
  // const mobilefullImage = mobileimage?.node?.localFile?.childImageSharp?.full

  return (
    <Figure>
      <img
        className="mobile"
        src={mobileurl
          .replace('http://', 'https://')
          .replace(
            'legacy2.ltnext.com/wp-content/uploads/2021/10/',
            'interactivo.latercera.com/18o-assets/',
          )
          .replace(
            'legacy2.ltnext.com/wp-content/uploads/2022/01/',
            'interactivo.latercera.com/18o-assets/',
          )}
        alt=""
      />
      <img
        className="desktop"
        src={url
          .replace('http://', 'https://')
          .replace(
            'legacy2.ltnext.com/wp-content/uploads/2021/10/',
            'interactivo.latercera.com/18o-assets/',
          )
          .replace(
            'legacy2.ltnext.com/wp-content/uploads/2022/01/',
            'interactivo.latercera.com/18o-assets/',
          )}
        alt=""
      />
    </Figure>
  )
}

export default Image
